module.exports = __webpack_public_path__ + "img/img-10.bce7e9a3.png";